import api from '../../../services/Api';
import { IAuditoriaCaixaFornecedoresResultado } from '../interfaces/IAuditoriaCaixaFornecedores';

interface BuscarParams {
  empresaId: number;
  periodo: string | undefined;
}

export const AuditoriaCaixaFornecedoresService = {
  buscarResultado: async (params: BuscarParams): Promise<IAuditoriaCaixaFornecedoresResultado> => {
    const response = await api.get<IAuditoriaCaixaFornecedoresResultado>(
      'auditoria-caixa-fornecedores/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
